import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { imgArray, mobileArray } from '../utils/imgArray';
import { Carrusel } from './Carrusel';

export const PopUp = (props) => {

    const [mobile, setMobile] = useState(false)

    useEffect(() => {
        const width = window.innerWidth
        if(width < 500){
            setMobile(true)
        }
    }, [])

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton >
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "black"}}>
                <Carrusel 
                    imagenes={!mobile ? imgArray.julia : mobileArray.julia}
                />
                <Carrusel 
                    imagenes={!mobile ? imgArray.nadia : mobileArray.nadia}
                />
                <Carrusel 
                    imagenes={ !mobile ? imgArray.diana : mobileArray.diana}
                />
                <Carrusel 
                    imagenes={!mobile ? imgArray.daniela : mobileArray.daniela}
                />
            </Modal.Body>
        </Modal>
    )
}
